import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { gsap } from "gsap";
import Shared03Divider from "../../../guestsharedcomponents/Shared03Divider/Shared03Divider";
import Shared05Stars from "../../../guestsharedcomponents/Shared05Stars/Shared05Stars";

const ContainerDiv = styled.div`
  width: 100%;
  overflow: hidden;

  /* MAIN REVIEW */
  .main-review {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 1.5rem;
    margin-bottom: 8rem;
    box-shadow: 0 0 40px rgba(255, 180, 90, 0.15);
    border: 0.1rem solid rgba(255, 215, 160, 0.25);
  }

  .main-review-img {
    flex: 0 0 100%;
    max-width: 100%;

    img {
      border-top-left-radius: 1.5rem;
      border-top-right-radius: 1.5rem;
      max-height: 35rem;
      object-position: top;
    }
  }

  .label-dancing {
    position: absolute;
    bottom: -2.1rem;
    left: 0;
    right: 0;
    max-width: 47rem;
    margin: 0 auto;

    .label-m {
      display: block;
      text-align: center;
      padding: 1rem;
      color: var(--brand-1);
      background: linear-gradient(90deg, transparent, #000, transparent);
    }
  }

  .main-content {
    flex: 1;
    text-align: center;
    padding: 2rem 2rem 6rem 2rem;
  }

  .stars_customer i {
    color: var(--brand-1);
    margin-bottom: 1.5rem;
    margin-right: 0.7rem;
  }

  .review-text {
    font-size: 1.6rem;
    line-height: 1.6;
    margin-bottom: 20px;
    color: #f5e7d3;
    opacity: 0.8;
  }

  .author {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--brand-1);
  }

  .arrows {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
  }

  .arrow {
    pointer-events: all;
    font-size: 32px;
    cursor: pointer;
    padding: 20px;
  }

  /* STATS */

  .student-stars {
    margin: 0 auto 5rem auto;
    max-width: 50rem;

    span {
      font-size: 6rem;
      color: var(--brand-1);
      font-weight: 700;
    }

    .stars-review {
      display: flex;
      align-items: center;
      padding: 1rem 1.5rem;
    }

    .stars-review i {
      font-size: 4rem;
      margin-right: 0.7rem;
      color: var(--brand-1);
    }

    .student-p {
      flex: 0 0 100%;
      max-width: 100%;
      text-align: center;
      color: #f5e7d3;
      font-size: 1.8rem;
    }
  }

  /* GRID REVIEWS */
  .grid {
    display: grid;
    gap: 24px;
  }

  .card {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 1.5rem;
    box-shadow: 0 0 40px rgba(255, 180, 90, 0.15);
    border: 0.1rem solid rgba(255, 215, 160, 0.25);
    padding: 2rem;

    .customer-info {
      flex: 1;
    }

    .customer-img {
      flex: 0 0 5rem;
      max-width: 6rem;
      height: 5rem;
      margin-right: 1rem;

      img {
        border-radius: 50%;
        border: 0.1rem solid rgba(255, 215, 160, 0.25);
      }
    }

    .customer-name {
      font-size: 1.4rem;
      color: var(--brand-1);
      font-weight: 700;
    }

    .stars-card i {
      color: #f5e7d3;
      font-size: 1.1rem;
      margin-right: 0.5rem;
    }

    .customer-review {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: #f5e7d3;
      font-size: 1.3rem;
    }
  }

  @media only screen and (min-width: 764px) {
    .main-review-img {
      flex: 0 0 26rem;
      max-width: 26rem;
      height: 35rem;

      img {
        border-top-left-radius: 1.5rem;
        border-top-right-radius: 0;
        border-bottom-left-radius: 1.5rem;
        max-height: 35rem;
      }
    }

    .main-content {
      text-align: left;
      padding: 2rem 6rem;
    }

    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media only screen and (min-width: 992px) {
    .t-container {
      padding: 0 10rem;
    }
  }

  @media only screen and (min-width: 1300px) {
    .grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;

const ContainerTestimonial = () => {
  const mainRef = useRef(null);
  const [index, setIndex] = useState(0);

  const array_customer = [
    {
      _id: "1",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417257/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-female_pb3kb4.webp",
      customer_name: "Emily R.",
      customer_stars: "5.0",
      customer_review:
        "I started with no experience at all. The structure made everything clear and helped me build confidence fast.",
      customer_country: "United States",
    },
    {
      _id: "2",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417253/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-male_as4nrp.webp",
      customer_name: "Jason M.",
      customer_stars: "5.0",
      customer_review:
        "I had danced before, but LT Mastery helped me finally understand connection and technique in a deeper way.",
      customer_country: "United States",
    },
    {
      _id: "3",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417257/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-female_pb3kb4.webp",
      customer_name: "Sarah L.",
      customer_stars: "5.0",
      customer_review:
        "The progress tracking keeps me consistent. I always know what to train next without feeling overwhelmed.",
      customer_country: "United States",
    },
    {
      _id: "4",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417253/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-male_as4nrp.webp",
      customer_name: "Michael T.",
      customer_stars: "5.0",
      customer_review:
        "Training solo helped me improve faster. I feel more confident and relaxed when dancing socially now.",
      customer_country: "United States",
    },
    {
      _id: "5",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417257/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-female_pb3kb4.webp",
      customer_name: "Sofia G.",
      customer_stars: "5.0",
      customer_review:
        "The lessons are clear and well structured. I finally feel progress instead of jumping between random videos.",
      customer_country: "United States",
    },
    {
      _id: "6",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417253/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-male_as4nrp.webp",
      customer_name: "Carlos M.",
      customer_stars: "5.0",
      customer_review:
        "Nunca había entrenado bachata así. Todo tiene sentido y mi baile mejoró mucho en poco tiempo.",
      customer_country: "Mexico",
    },
    {
      _id: "7",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417257/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-female_pb3kb4.webp",
      customer_name: "Ana P.",
      customer_stars: "5.0",
      customer_review:
        "Me encanta la claridad del sistema. Entreno sola y noto avances reales cada semana.",
      customer_country: "Spain",
    },
    {
      _id: "8",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417253/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-male_as4nrp.webp",
      customer_name: "David R.",
      customer_stars: "5.0",
      customer_review:
        "He tomado muchas clases antes, pero esta es la primera vez que siento un progreso estructurado.",
      customer_country: "Spain",
    },
    {
      _id: "9",
      customer_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1770417257/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-tay-bachata-student-silhouette-female_pb3kb4.webp",
      customer_name: "Mariana L.",
      customer_stars: "5.0",
      customer_review:
        "La plataforma me ayudó a entrenar con constancia y entender mejor mi cuerpo y la música.",
      customer_country: "Mexico",
    },
  ];

  const total = array_customer.length;

  const current = array_customer[index % total];

  const next = () => setIndex((i) => i + 1);
  const prev = () => setIndex((i) => (i - 1 + total) % total);

  useEffect(() => {
    gsap.fromTo(
      mainRef.current,
      { opacity: 0, x: 40 },
      { opacity: 1, x: 0, duration: 0.5 }
    );
  }, [index]);

  const shuffled = [...array_customer]
    .sort(() => 0.5 - Math.random())
    .slice(0, window.innerWidth > 992 ? 4 : 2);

  return (
    <ContainerDiv className="t-0fe">
      <div className="t-container">
        <div className="main-review" ref={mainRef}>
          <div className="main-review-img">
            <img src={current.customer_img} alt={current.customer_name} />
          </div>

          <div className="main-content">
            <Shared05Stars
              options={{
                container_classes: "stars_customer",
                star_value: "5.0",
              }}
            />
            <div className="review-text">“{current.customer_review}”</div>
            <div className="author">
              {current.customer_name} – {current.customer_country}
            </div>
          </div>

          <div className="arrows">
            <div className="arrow" onClick={prev}>
              <i className="fa-solid fa-angle-left"></i>
            </div>
            <div className="arrow" onClick={next}>
              <i className="fa-solid fa-angle-right"></i>
            </div>
          </div>

          <div className="label-dancing">
            <Shared03Divider
              options={{
                obj_divider: {
                  divider_mobile_styles: {
                    width: "100%",
                    background:
                      "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                    margin: "0 auto",
                  },
                  divider_desktop_styles: false,
                },
                style_render: false,
              }}
            />

            <span className="label-m">Start Dancing With Confidence</span>

            <Shared03Divider
              options={{
                obj_divider: {
                  divider_mobile_styles: {
                    width: "100%",
                    background:
                      "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                    margin: "0 auto",
                  },
                  divider_desktop_styles: false,
                },
                style_render: false,
              }}
            />
          </div>
        </div>

        <div className="student-stars t-flex-op4 t-pr">
          <Shared03Divider
            options={{
              obj_divider: {
                divider_mobile_styles: {
                  width: "25%",
                  background:
                    "linear-gradient(90deg, transparent, #e6c28b, #e6c28b)",
                  position: "absolute",
                  top: "7rem",
                  left: "0",
                },
                divider_desktop_styles: {
                  width: "35%",
                  top: "3.5rem",
                  left: "-17rem",
                },
              },
              style_render: 526,
            }}
          />

          <span>200+</span>
          <Shared05Stars
            options={{
              container_classes: "stars-review",
              star_value: "5.0",
            }}
          />
          <p className="student-p">
            Five-Star Student Reviews, from over 20+ countries trust LT Mastery
          </p>

          <Shared03Divider
            options={{
              obj_divider: {
                divider_mobile_styles: {
                  width: "25%",
                  background:
                    "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
                  position: "absolute",
                  top: "7rem",
                  right: "0",
                },
                divider_desktop_styles: {
                  width: "35%",
                  top: "3.5rem",
                  right: "-16rem",
                },
              },
              style_render: 526,
            }}
          />
        </div>

        <div className="grid">
          {shuffled.map((c) => (
            <div className="card" key={c._id}>
              <div className="t-flex-ac t-mb-2">
                <div className="customer-img">
                  <img src={c?.customer_img} alt={c?.customer_review} />
                </div>

                <div className="customer-info">
                  <span className="customer-name">{c.customer_name}</span>
                  <Shared05Stars
                    options={{
                      container_classes: "stars-card",
                      star_value: "5.0",
                    }}
                  />
                </div>
              </div>

              <p className="customer-review">{c.customer_review}</p>
            </div>
          ))}
        </div>
      </div>
    </ContainerDiv>
  );
};

export default ContainerTestimonial;
